module.exports = __webpack_public_path__ + "img/teeth.f2156f5c.png";